import { CommonModule } from '@angular/common';
import { CheckboxFilterComponent } from './checkbox-filter/checkbox-filter.component';
import { CheckBoxComponent } from './check-box/check-box.component';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import {MatCheckboxModule} from "@angular/material/checkbox";

@NgModule({
	declarations: [CheckBoxComponent, CheckboxFilterComponent],
    imports: [FormsModule, CommonModule, MatFormFieldModule, MatInputModule, MatCheckboxModule],
	exports: [CheckBoxComponent, CheckboxFilterComponent]
})
export class CheckBoxModule {}
